import type { Transition, Variants } from "framer-motion";

/** Expressive ease-out curve used across admin v2. */
export const easeOut: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** Lightweight ease-out tween simulating a soft spring for cards, popovers and shared-layout transitions. */
export const springSoft: Transition = {
  type: "tween",
  duration: 0.3,
  ease: easeOut,
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3, ease: easeOut } },
};

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: easeOut } },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: springSoft },
};

/** Parent that staggers its children when they enter. */
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06, delayChildren: 0.05 },
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: easeOut } },
};
